import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import SettingsTab from './Partials/SettingsTab';

import * as AccessCheck from '../../Common/Utils/AccessCheck';
import PermissionToolbar from '../../Common/Toolbar';
import RequiredRole from './StaticData/RequiredRole';
import Title from '../../Common/Title';
import UserTitleName from './StaticData/TitleName';

type Props = {
  basePath: string,
  permissions: any,
  record: any,
  resource: string
};

const UserEdit = (props: Props) => (
  <Edit title={<Title title={UserTitleName} record={props.record} />} actions={null} {...props}>
    <SimpleForm
      redirect="edit"
      toolbar={<PermissionToolbar
        accessCheck={AccessCheck.Edit(props.permissions, RequiredRole)}
        basePath={props.basePath}
        record={props.record}
        resource={props.resource} />}
    >
      <SettingsTab record={props.record} />
    </SimpleForm>
  </Edit>
);

export default UserEdit;



// WEBPACK FOOTER //
// ./src/views/Components/Users/Edit.tsx